import { render, staticRenderFns } from "./First.vue?vue&type=template&id=53a841dc&scoped=true&"
import script from "./First.vue?vue&type=script&lang=ts&"
export * from "./First.vue?vue&type=script&lang=ts&"
import style0 from "./First.vue?vue&type=style&index=0&id=53a841dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a841dc",
  null
  
)

export default component.exports